module.exports = __webpack_public_path__ + "static/media/Flaticon.c9987203.svg";